var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "container pt-5 pb-5" },
    [
      _c(_setup.ComponentSettingsForm),
      _vm._v(" "),
      _c("div", { staticClass: "list-group" }, [
        _c(
          "div",
          { staticClass: "list-group-item" },
          [_c(_setup.ComponentSettingsDuplicateFormItem)],
          1
        ),
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Danger zone")]),
      _vm._v(" "),
      _c("div", { staticClass: "list-group" }, [
        _c(
          "div",
          { staticClass: "list-group-item danger-list-group-item" },
          [_c(_setup.ComponentSettingsDeleteFormItem)],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }